import { CustomError } from "./CustomError";
export const throwCustomError = (error, customError400Obj) => {
	if (error?.statusCode === 401 || error?.statusCode === 403) {
		var customObj =
			error?.statusCode === 401
				? UNAUTHORISED_ERROR_MESSAGE
				: TOKEN_ERROR_MESSAGE;
		throw new CustomError(
			customObj.name,
			error.statusCode,
			customObj.message,
			false
		);
	} else if (
		error.name?.indexOf("Failed to fetch") >= 0 ||
		error.statusCode === 500
	) {
		throw new CustomError(
			TOKEN_ERROR_MESSAGE.name,
			error?.statusCode ? error.statusCode : 500,
			TOKEN_ERROR_MESSAGE.message,
			false
		);
	} else if (error.name === "AbortError") {
		throw new CustomError(
			TIMEOUT_ERROR_MESSAGE.name,
			error?.statusCode ? error.statusCode : 500,
			TIMEOUT_ERROR_MESSAGE.message,
			false
		);
	} else {
		if (!customError400Obj) throw error;
		throw new CustomError(
			customError400Obj.name,
			error.statusCode,
			customError400Obj.message,
			true
		);
	}
};

export const TOKEN_ERROR_MESSAGE = {
	name: "Unauthorised Access",
	message:
		"We couldn't sign you in with the credentials provided. Are you sure you are signing in with the correct email address?",
};

export const UNAUTHORISED_ERROR_MESSAGE = {
	name: "Unauthorised",
	message: "Unauthrorised action for this user",
};

export const TIMEOUT_ERROR_MESSAGE = {
	name: "Timeout",
	message: "Your request has timed out. Please try again",
};

export const UNSPECIFIED_ERROR_MESSAGE = {
	name: "Unspecified network error",
	message: "Please try again. If the error persists, please contact support",
};

export const FORMS_ERROR_MESSAGE = {
	name: "Error",
	message: "Unspecified application error",
};

export const FORM_BY_ID_ERROR_MESSAGE = {
	name: "Error while loading form",
	message:
		"The data you requested could not be loaded. Please try again. If problems persist, please contact support.",
};

export const FORMDEFINITION_BY_ID_ERROR_MESSAGE = {
	name: "Error while loading form",
	message:
		"The data you requested could not be loaded. Please try again. If problems persist, please contact support.",
};

export const ATTACHMENT_BY_ID_ERROR_MESSAGE = {
	name: "Error while downloading attachment",
	message: `There was an error downloading this attachment`,
};

export const UPLOAD_DOCUMENTS_ERROR_MESSAGE = {
	name: "Error while loading attachments",
	message: "There was an error loading attachments",
};

export const WORKFLOWS_BY_FORMID_ERROR_MESSAGE = {
	name: "Error while loading workflows",
	message:
		"The workflows you requested could not be loaded. Please try again. If problems persist, please contact support.",
};

export const POST_FORMDEFINITION_ERROR_MESSAGE = {
	name: "Error while saving form definition",
	message:
		"Your form definition has NOT been saved. Please try again. If problems persist, please contact support.",
};

export const POST_RESPONSEFORM_ERROR_MESSAGE = {
	name: "Error while saving form",
	message:
		"Your form has NOT been saved. Please try again. If problems persist, please contact support.",
};

export const UPLOAD_DOCUMENT_ERROR_MESSAGE = {
	name: "Error while uploading attachment",
	message:
		"Your upload file has NOT been saved. Please try again. If problems persist, please contact support.",
};

export const USER_DEFINE_TEMPLATE_ERROR_MESSAGE = {
	name: "Error while creating workflows",
	message:
		"Could not create your workflows from the template. Please try again. If problems persist, please contact support.",
};

export const POST_WORKFLOW_ERROR_MESSAGE = {
	name: "Error while saving workflows",
	message:
		"Could not save your workflows. Please try again. If problems persist, please contact support.",
};

export const SUBMIT_WORKFLOW_ERROR_MESSGE = {
	name: "Error while submitting workflows",
	message:
		"Could not submit your workflows. Please try again. If problems persist, please contact support.",
};

export const RESET_WORKFLOW_ERROR_MESSGE = {
	name: "Error while updating workflows",
	message:
		"Could not update your workflows. Please try again. If problems persist, please contact support.",
};

export const RESUME_WORKFLOW_ERROR_MESSAGE = {
	name: "Error while updating workflows",
	message:
		"Could not update your workflows. Please try again. If problems persist, please contact support.",
};

export const APPROVE_WORKFLOW_ERROR_MESSAGE = {
	name: "Error while updating workflows",
	message:
		"Could not update your workflows. Please try again. If problems persist, please contact support.",
};

export const DECLINE_WORKFLOW_ERROR_MESSAGE = {
	name: "Error while updating workflows",
	message:
		"Could not update your workflows. Please try again. If problems persist, please contact support.",
};

export const UPSERT_WORKFLOW_ERROR_MESSAGE = {
	name: "Error while updating workflows",
	message:
		"Could not update your workflows. Please try again. If problems persist, please contact support.",
};

export const TREE_BY_DOMAIN_ERROR_MESSAGE = {
	name: "Error",
	message: "Unspecified application error",
};

export const GENERIC_ERROR_MESSAGE = {
	name: "Error while loading data",
	message:
		"The data you requested could not be loaded. Please try again. If problems persist, please contact support.",
};

export const GENERIC_POST_ERROR_MESSAGE = {
	name: "Error while submitting your request",
	message:
		"Your request could not be processed. Please try again. If problems persist, please contact support.",
};
